import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8f9920a8")
const _hoisted_1 = { id: "customize-component" }
const _hoisted_2 = { id: "color-inputs" }
const _hoisted_3 = { class: "color-input-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Fill", -1)
const _hoisted_5 = { class: "color-input-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Border", -1)
const _hoisted_7 = { id: "range-inputs" }
const _hoisted_8 = { class: "range-wrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Border Width", -1)
const _hoisted_10 = { class: "range-wrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Transparency", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          id: "fill-circle",
          ref: "fillElement",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleColorPickr && _ctx.handleToggleColorPickr(...args)))
        }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          id: "border-circle",
          ref: "borderElement",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleToggleColorPickr && _ctx.handleToggleColorPickr(...args)))
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("input", {
          type: "range",
          min: "0",
          max: "100",
          class: "slider",
          ref: "borderWidthRange",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBorderWidth && _ctx.handleBorderWidth(...args)))
        }, null, 544),
        _createElementVNode("div", null, _toDisplayString(_ctx.borderWidth) + "px", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("input", {
          type: "range",
          min: "0",
          max: "100",
          class: "slider",
          ref: "transparencyRange",
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleTransparency && _ctx.handleTransparency(...args)))
        }, null, 544),
        _createElementVNode("div", null, _toDisplayString(_ctx.opacity) + "%", 1)
      ])
    ])
  ]))
}